import React, { useEffect, useState, useCallback } from 'react';
import {
  Row, Col, Card, Statistic, Typography, Space, Tag, Empty, Progress,
} from 'antd';
import { FolderOpenOutlined, DatabaseOutlined, FileOutlined } from '@ant-design/icons';
import { fetchStorage } from '../services/documentService';
import { fetchSettings } from '../services/settingsService';
import DocumentManager from './DocumentManager';

const { Title, Text } = Typography;

const fmtSize = (b) => {
  if (!b) return '0 B';
  if (b < 1024) return `${b} B`;
  if (b < 1048576) return `${(b / 1024).toFixed(0)} KB`;
  return `${(b / 1048576).toFixed(1)} MB`;
};

const Documents = () => {
  const [storage, setStorage] = useState({ files: 0, bytes: 0, byCategory: [] });
  const [settings, setSettings] = useState({});

  const loadStorage = useCallback(async () => {
    try { setStorage(await fetchStorage()); } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    loadStorage();
    (async () => { try { setSettings(await fetchSettings()); } catch { /* ignore */ } })();
  }, [loadStorage]);

  const maxBytes = Math.max(1, ...(storage.byCategory || []).map(c => Number(c.bytes)));

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16, padding: '4px 8px' }}>
        <Col>
          <Title level={4} style={{ margin: 0 }}>Document Management</Title>
          <Text type="secondary">Central library for lead &amp; client documents</Text>
        </Col>
      </Row>

      <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
        <Col xs={12} md={6}>
          <Card bordered={false} style={{ borderRadius: 8 }}>
            <Statistic title="Total Files" value={Number(storage.files) || 0} prefix={<FileOutlined />} valueStyle={{ color: '#e27e56' }} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card bordered={false} style={{ borderRadius: 8 }}>
            <Statistic title="Storage Used" value={fmtSize(Number(storage.bytes) || 0)} prefix={<DatabaseOutlined />} valueStyle={{ color: '#722ed1' }} />
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card bordered={false} style={{ borderRadius: 8 }} bodyStyle={{ padding: '12px 16px' }}>
            <Text type="secondary"><FolderOpenOutlined /> By category</Text>
            <div style={{ marginTop: 8, maxHeight: 80, overflow: 'auto' }}>
              {(storage.byCategory || []).length === 0 ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No files" />
                : storage.byCategory.map(c => (
                  <div key={c.Category} style={{ marginBottom: 4 }}>
                    <Space style={{ justifyContent: 'space-between', width: '100%' }}>
                      <Text style={{ fontSize: 12 }}>{c.Category} <Text type="secondary">({c.files})</Text></Text>
                      <Text type="secondary" style={{ fontSize: 12 }}>{fmtSize(Number(c.bytes))}</Text>
                    </Space>
                    <Progress percent={Math.round((Number(c.bytes) / maxBytes) * 100)} showInfo={false} size="small" strokeColor="#e27e56" />
                  </div>
                ))}
            </div>
          </Card>
        </Col>
      </Row>

      <Card bordered={false} style={{ borderRadius: 8 }} bodyStyle={{ padding: 16 }}>
        <DocumentManager settings={settings} onChanged={loadStorage} />
      </Card>
    </div>
  );
};

export default Documents;
